import { render, staticRenderFns } from "./YardControlBodiesList.vue?vue&type=template&id=2697fa17&"
import script from "./YardControlBodiesList.vue?vue&type=script&lang=js&"
export * from "./YardControlBodiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports